<template>
    <div class="container">
      <h1>Gerador de QR Code</h1>
      <p class="description">Digite um texto ou URL e gere um QR Code instantaneamente.</p>
  
      <div class="qr-box">
        <input v-model="inputText" placeholder="Digite um texto ou URL" />
        <button @click="generateQRCode">Gerar QR Code</button>
      </div>
  
      <canvas ref="qrCanvas"></canvas>
  
      <div v-if="qrGenerated" class="download-box">
        <button @click="downloadQRCode">Baixar QR Code</button>
      </div>
    </div>
  </template>
  
  <script>
  import QRCode from "qrcode";
  
  export default {
    name: "QRCodeGenerator",
    data() {
      return {
        inputText: "",
        qrGenerated: false
      };
    },
    methods: {
      async generateQRCode() {
        if (!this.inputText) {
          alert("Digite um texto ou URL para gerar o QR Code!");
          return;
        }
  
        const canvas = this.$refs.qrCanvas;
        await QRCode.toCanvas(canvas, this.inputText, {
          width: 250,
          margin: 2
        });
  
        this.qrGenerated = true;
      },
      downloadQRCode() {
        const canvas = this.$refs.qrCanvas;
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png");
        link.download = "qrcode.png";
        link.click();
      }
    }
  };
  </script>
  
  <style scoped>
  .container {
    max-width: 500px;
    margin: auto;
    padding: 20px;
    text-align: center;
    font-family: "Arial", sans-serif;
  }
  
  h1 {
    font-size: 24px;
    margin-bottom: 10px;
  }
  
  .description {
    font-size: 16px;
    color: #555;
    margin-bottom: 20px;
  }
  
  .qr-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
  }
  
  input {
    width: 80%;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
    text-align: center;
  }
  
  button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 18px;
    border-radius: 5px;
    cursor: pointer;
    transition: 0.3s;
  }
  
  button:hover {
    background-color: #0056b3;
  }
  
  canvas {
    margin-top: 10px;
    border: 1px solid #ccc;
    padding: 10px;
    background: white;
  }
  
  .download-box {
    margin-top: 20px;
  }
  </style>
  